import { useCallback, useContext } from "react";
// api
import { useUpdateCredMutation } from "../../../../../../services/matches";
// types
import { ICredential, IUpdateCredentialPayload } from "../../../../types/credential";
// context
import UserContext from "../../../../../../contexts/UserContext";
// custom hooks
import { useAppDispatch } from "../../../../hooks/storeHooks";
import { updateCred } from "../../../../reducers/credentialsSlice";
import useGetCredentialJoid from "../../../../hooks/useGetCredentialJoid";

type UpdateCredential = {
  title: string;
  credential: ICredential;
  onSuccess?: () => void;
  onError?: () => void;
  onEnd?: () => void;
}

interface IUseUpdateCrendentialProps {
  credential?: ICredential | undefined;
}

const useUpdateCredential = ({ credential }: IUseUpdateCrendentialProps) => {
  // context
  const _userModel = useContext(UserContext);
  const credentialJoid = useGetCredentialJoid({ credential });

  // store
  const dispatch = useAppDispatch();

  // api
  const [updateCredMutation, { isLoading: isUpdating }] = useUpdateCredMutation();

  const updateCredential = useCallback(async ({
    title,
    credential,
    onSuccess,
    onError,
    onEnd,
  }: UpdateCredential) => {
    const credParams: IUpdateCredentialPayload = {
      credential: {
        ...credential,
        name: title,
        project: undefined,
      },
      joid: credentialJoid,
    };
    try {
      const updatedCred = await updateCredMutation(credParams).unwrap();
      const _cred = Object.assign({}, updatedCred?.data);
      dispatch(updateCred(_cred));

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error("Failed to updated credential", error);
      if (onError) {
        onError();
      }
    } finally {
      if (onEnd) {
        onEnd();
      }
    }
  }, [updateCred, credentialJoid]);

  return {
    updateCredential,
    isUpdating
  }
};

export default useUpdateCredential;